import { render, staticRenderFns } from "./MotionEffectsList.vue?vue&type=template&id=21f32d01"
import script from "./MotionEffectsList.vue?vue&type=script&lang=js"
export * from "./MotionEffectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports